import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Autocomplete
} from "@mui/material";

const ProductManager = ({ onProductDataChange }) => {
  const [sections, setSections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  const [selectedSection, setSelectedSection] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");

  const [sectionSeq, setSectionSeq] = useState("");
  const [categorySeq, setCategorySeq] = useState("");
  const [brandSeq, setBrandSeq] = useState("");

  useEffect(() => {
    loadSections();
    loadBrands();
  }, []);

  async function loadSections() {
    const response = await fetch("/categorias/secciones/");
    const data = await response.json();
    setSections(data);
  }

  async function loadBrands() {
    const response = await fetch("/categorias/marcas/");
    const data = await response.json();
    setBrands(data);
  }

  async function loadCategories(sectionId) {
    const response = await fetch(`/categorias/seccion/${sectionId}/`);
    const data = await response.json();
    setCategories(data);
    setSelectedCategory("");
    setSelectedBrand("");
    setCategorySeq("");
    setBrandSeq("");
  }

  async function getNextSequential(base) {
    const response = await fetch(`/productos/next/?base=${base}`);
    const data = await response.json();
    return data.next || "01";
  }

  async function generateFinalCode(seqSec, seqCat, seqBrand) {
    if (!seqSec || !seqCat || !seqBrand) return "";
    const base = seqSec + seqCat + seqBrand;
    const correlativo = await getNextSequential(base);
    return base + correlativo;
  }

  useEffect(() => {
    if (selectedSection) {
      const sec = sections.find((s) => s.id === selectedSection);
      setSectionSeq(sec ? sec.sequential_code : "");
      loadCategories(selectedSection);
    } else {
      setCategories([]);
      setSelectedCategory("");
      setSelectedBrand("");
      setSectionSeq("");
      setCategorySeq("");
      setBrandSeq("");
    }
  }, [selectedSection]);

  useEffect(() => {
    if (selectedCategory) {
      const cat = categories.find((c) => c.id === selectedCategory);
      setCategorySeq(cat ? cat.sequential_code : "");
    } else {
      setCategorySeq("");
      setSelectedBrand("");
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (selectedBrand) {
      const br = brands.find((b) => b.id === selectedBrand);
      setBrandSeq(br ? br.sequential_code : "");
    } else {
      setBrandSeq("");
    }
  }, [selectedBrand]);

  useEffect(() => {
    async function updateFinal() {
      if (sectionSeq && categorySeq && brandSeq) {
        const code = await generateFinalCode(sectionSeq, categorySeq, brandSeq);
        onProductDataChange({
          section: selectedSection,
          category: selectedCategory,
          brand: selectedBrand,
          section_seq: sectionSeq,
          category_seq: categorySeq,
          brand_seq: brandSeq,
          code: code
        });
      } else {
        onProductDataChange({
          section: selectedSection,
          category: selectedCategory,
          brand: selectedBrand,
          section_seq: sectionSeq,
          category_seq: categorySeq,
          brand_seq: brandSeq,
          code: ""
        });
      }
    }
    updateFinal();
  }, [sectionSeq, categorySeq, brandSeq]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1565C0" }}>
        Gestión de Productos
      </Typography>

      <Typography variant="subtitle2" sx={{ mb: 3, color: "black", fontWeight: "bold" }}>
        Los campos con (*) son obligatorios
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Autocomplete
            options={sections.sort((a, b) => a.name.localeCompare(b.name))}
            getOptionLabel={(option) => option.name}
            value={sections.find((s) => s.id === selectedSection) || null}
            onChange={(e, value) => setSelectedSection(value ? value.id : "")}
            renderInput={(params) => (
              <TextField {...params} label="Seleccionar Sección" required />
            )}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Autocomplete
            options={categories.sort((a, b) => a.name.localeCompare(b.name))}
            getOptionLabel={(option) => option.name}
            value={categories.find((c) => c.id === selectedCategory) || null}
            onChange={(e, value) => setSelectedCategory(value ? value.id : "")}
            renderInput={(params) => (
              <TextField {...params} label="Seleccionar Categoría" required />
            )}
            disabled={!selectedSection}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Autocomplete
            options={brands.sort((a, b) => a.name.localeCompare(b.name))}
            getOptionLabel={(option) => option.name}
            value={brands.find((b) => b.id === selectedBrand) || null}
            onChange={(e, value) => setSelectedBrand(value ? value.id : "")}
            renderInput={(params) => (
              <TextField {...params} label="Seleccionar Marca" required />
            )}
            disabled={!selectedCategory}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductManager;
